exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header[data-v-7f4576d4]{border-bottom:1px solid hsla(0,0%,100%,.08);height:81px;background-image:linear-gradient(90deg,#003873,#004a87,#005d9a,#0070ad,#0284c0);white-space:nowrap}.logo[data-v-7f4576d4]{cursor:pointer}header a[data-v-7f4576d4]{color:#fff}.content>.right-block[data-v-7f4576d4],.content[data-v-7f4576d4]{display:flex;justify-content:space-between;height:100%}nav>.nav-btn[data-v-7f4576d4],nav[data-v-7f4576d4]{display:flex;height:100%}nav>.nav-btn[data-v-7f4576d4]:first-child{margin-left:0}nav>.nav-btn[data-v-7f4576d4]:last-child{margin-right:0}nav>.nav-btn>span[data-v-7f4576d4]{margin:auto;margin:auto 13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f4576d4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Header.vue
// module id = 87
// module chunks = 6